/**
 * settings/Integration domain (GHL locations lookup + "Your AI" location
 * connect) - built on apiClient via useRequest, not useAppServices(). Shared
 * by:
 *   - settings/Integration/index.js (GHL locations list)
 *   - settings/Integration/components/MybeConnect/index.js (connect/
 *     disconnect a GHL location)
 * settings/Integration/components/StripeCoonection/index.js's own
 * update_stripe/agency-update calls reuse queries/agency.js's hooks instead
 * (useUpdateAgencyStripe, useUpdateAgency) - its three AppService.saas.*
 * calls are inlined directly via useRequest() there instead, since the
 * "saas" domain belongs to another fork.
 */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useRequest from "hook/useRequest";
import { ReqMethods } from "enums";

const { GET, PUT } = ReqMethods;

export function useGhlLocations(agencyId, options = {}) {
  const request = useRequest();
  return useQuery({
    queryKey: ["ghl-locations", agencyId],
    queryFn: async () => {
      const { response, error } = await request(GET, "/overview/ghlLocation", {
        query: `agency_id=${agencyId}`,
      });
      if (error) throw error;
      return response?.data;
    },
    enabled: !!agencyId,
    ...options,
  });
}

export function useUpdateMaybeLocation() {
  const request = useRequest();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => request(PUT, "/brand/update-location", { payload }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["agency"] }),
  });
}
